import React from 'react';
import './ImageModal.css';

interface ImageModalProps {
  selectedImage: {
    url: string;
    name: string;
    index: number;
  } | null;
  onClose: () => void;
  onDownload: () => Promise<void>;
  isDownloading: boolean;
}

const ImageModal: React.FC<ImageModalProps> = ({ selectedImage, onClose, onDownload, isDownloading }) => {
  if (!selectedImage) return null;

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Escape') {
      onClose();
    }
  };

  const handleDownload = async () => {
    try {
      await onDownload();
    } catch (error) {
      console.error('ダウンロードエラー:', error);
      alert('画像のダウンロードに失敗しました');
    }
  };

  return (
    <div 
      className="modal-overlay" 
      onClick={onClose}
      onKeyDown={handleKeyDown}
      tabIndex={0}
    >
      <div 
        className="modal-content" 
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header">
          <h3>{selectedImage.name} - 画像{selectedImage.index}</h3>
          <button 
            className="modal-close-btn" 
            onClick={onClose}
            aria-label="モーダルを閉じる"
          >
            ×
          </button>
        </div>
        
        <div className="modal-image-container">
          <img
            src={selectedImage.url}
            alt={`${selectedImage.name} - 画像${selectedImage.index}`}
            className="modal-image"
          />
        </div>
        
        <div className="modal-footer">
          <button 
            className="download-btn" 
            onClick={handleDownload}
            disabled={isDownloading}
          >
            {isDownloading ? '📥 ダウンロード中...' : '📥 ダウンロード'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImageModal;